// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: team threads: what a thread view knows about its sharing, for the parts inside it (kept
// light so any part of the thread view can read it).

import type {AgentSharedThread, AgentThreadShare} from '@fluxer/schema/src/domains/konvo/AgentShares';
import {createContext, useContext} from 'react';

/** What the thread view knows about its sharing, for the parts below. */
export interface ThreadShareValue {
	machineId: string;
	threadId: string;
	/** The caller owns the machine, or a teammate the thread is shared with. */
	role: 'owner' | 'teammate';
	share: AgentThreadShare | null;
	/** A teammate's entry from "Shared with you". */
	entry: AgentSharedThread | null;
	phone: boolean;
	/** The owner (with sharing on) or a teammate allowed to comment. */
	canComment: boolean;
	/** The owner's first name, "JP". */
	ownerFirst: string;
}

export const ThreadShareContext = createContext<ThreadShareValue | null>(null);
export const useThreadShare = () => useContext(ThreadShareContext);
